export default __webpack_public_path__ + "static/card-back-texture-9c740c387d1dc0f344a398a4ab439383.jpg";